import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import { BackgroundRemover } from "./components/pages/BgRemover/BackgroundRemover";
import { ImageExpand } from "./components/pages/ImageExpand";
import { ImageUpscale } from "./components/pages/ImageUpscale";
import { ImageProcess } from "./components/pages/ImageProcess";
import { Sidebar } from "./components/Sidebar";
import { BackgroundRemoverResult } from "./components/pages/ResponsePage/BackgroundRemoverResult";
import { Home } from "./components/pages/Home/Home";
//import { Profile } from "./components/pages/Profile/Profile-old";
import { ExpandResult } from "./components/pages/ResponsePage/ExpandResult";
import { UpscaleResult } from "./components/pages/ResponsePage/UpscaleResult";
import { ProcessedResult } from "./components/pages/ResponsePage/ProcessedResult";
import ImageSlider from "./components/ImageSlider";
import { HelpPage } from "./components/pages/HelpPage";
import { NotificationDropdown } from "./components/NotificationDropdown";
import ProtectedRoute from "./utils/ProtectedRoute";
import { AuthProvider } from "./AuthProvider";
import AccessControlProvider from "./AccessControlProvider";
import { Login } from "./components/pages/Login";
import { Pricing } from "../src/components/pages/Pricing/Pricing";
import { About } from "../src/components/pages/About/About";
import Signup from "./components/pages/Signup";
import ForgotPassword from "./components/pages/ForgotPassword";
import { AuthActionHandler } from "./components/pages/AuthActionHandler";
import { ToastContainer } from "react-fox-toast"
import { Blogs } from "./components/pages/blogs/Blogs";
import { BlogPage } from "./components/pages/blogs/BlogPage";

import { PolicyInfo } from "./components/PolicyInfo";
import { NewProfile } from "./components/pages/newProfilePage/NewProfile";
import { RecentActivities } from "./components/pages/Profile/RecentActivities";
import { Billing } from "./components/pages/Profile/Billing";
import Ai_model from "./components/pages/virtualAiIModel/Ai_model";
import BatchStatus from "./components/pages/BatchStatus/BatchStatus";
import BatchDetails from "./components/pages/BatchStatus/BatchDetails";
import { Terms } from "./components/Terms";
import TermsAndPrivacy from "./components/TermsAndPrivacy";
import {RefundPolicy} from "./components/RefundPolicy";
import { Chat } from "./components/Chat";
import { MobileMenuProvider } from "./MobileMenuContext";

function Layout() {
  return (
    <>
      <div className="flex h-screen text-gray-900 overflow-hidden">
        {/* Background */}
        <div className="fixed inset-0 z-0 bg-gradient-to-t from-sky-50 from-80% via-sky-100 to-sky-100">
          <div className="absolute inset-0 opacity-80" />
          <div className="absolute inset-0 backdrop-blur-sm" />
        </div>
        
        {/* Sidebar */}
        <Sidebar />
        
        {/* Main Content Area */}
        <div className="flex-grow relative z-10 overflow-auto">
          <Outlet />
        </div>
        
        {/* Chat Widget */}
        <Chat />
      </div>
    </>
  );
}

// Router Configuration
const router = createBrowserRouter([
  { path: "/", element: <Home/> },
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <Signup /> },
  { path: "/img", element: <ImageSlider /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/about", element: <About /> },
  { path: "/blogs", element: <Blogs /> },
  { path: "/blogs/:blogSlug", element: <BlogPage /> },
  { path: "/policy-info", element: <PolicyInfo /> },
  { path: "/terms", element: <Terms /> },
  { path: "/terms-and-privacy", element: <TermsAndPrivacy /> },
  { path: "/refund-policy", element: <RefundPolicy /> },
  { path: "/auth/action", element: <AuthActionHandler />},
  // In your router configuration
  { path: "/forgot-password", element: <ForgotPassword /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { path: "/Ai-model", element: <Ai_model /> },
      { path: "/batch-status", element: <BatchStatus /> },
      { path: "/batch-details/:batchId", element: <BatchDetails /> },
      { path: "/background-remover", element: <BackgroundRemover /> },
      { path: "/upload-bg-remover", element: <BackgroundRemoverResult /> },
      { path: "/upload-image-expand", element: <ExpandResult /> },
      { path: "/upload-image-upscale", element: <UpscaleResult /> },
      { path: "/upload-processed-image", element: <ProcessedResult /> },
      { path: "/image-expand", element: <ImageExpand /> },
      { path: "/image-up-scale", element: <ImageUpscale /> },
      { path: "/recentactivities", element: <RecentActivities /> },
      { path: "/help", element: <HelpPage /> },
      { path: "/billing", element: <Billing /> },
      { path: "/notification", element: <NotificationDropdown /> },
    ],
  },
]);

function App() {
  return (
    <AuthProvider>
      <AccessControlProvider>
        <MobileMenuProvider>
          <ToastContainer
            gap={10} // Gap need between each toast
            position='top-center' // default global position example 'top-center'
            isPausedOnHover={true}
          /> 
          <RouterProvider router={router} />
        </MobileMenuProvider>
      </AccessControlProvider>
    </AuthProvider>
  );
}

export default App;
